import { createAction, props } from '@ngrx/store';

export const ResetObjectSelection = createAction(
  '[Root] Reset Object Selection'
);

export const LanguageChanged = createAction(
  '[Root] Language Changed',
  props<{ lang: string }>(),
);

export const ReloadAppointments = createAction(
  '[Root] Reload Appointments',
  (payload: ReloadAppointmentsPayload = { ignoreSchedulerErrors: false }) => payload, // defined optional payload
);


export interface ReloadAppointmentsPayload {
  /**
   * Indicates whether to ignore scheduler errors once when reloading appointments.
   * Default is false. Set to true when reloading appointments after a block appointment is created.
   */
  ignoreSchedulerErrors: boolean
}
